import { render, staticRenderFns } from "./GSTstage.vue?vue&type=template&id=7519be83&scoped=true"
import script from "./GSTstage.vue?vue&type=script&lang=js"
export * from "./GSTstage.vue?vue&type=script&lang=js"
import style0 from "./GSTstage.vue?vue&type=style&index=0&id=7519be83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7519be83",
  null
  
)

export default component.exports